import { PrimeIcons } from 'primereact/api';
import { MenuItem } from 'primereact/menuitem';
import User, { CustomBranding, mapCustomBranding, Roles } from '../../models/User';

export const customDiagnosticOption = (item: MenuItem) => {
  return (
    <div className="p-menuitem-content">
      <a className="p-menuitem-link hover:text-white">
        <span className={`p-menuitem-icon icon ${item.icon}`} />
        <span className="mr-2 p-menuitem-text">{item.label}</span>
      </a>
    </div>
  );
};

export const getHeaderOptionsByRole = (userRedux: User, navigate: (url: string) => void) => {
  const miamiBrand =
    userRedux?.network?.customBranding &&
    mapCustomBranding[userRedux?.network?.customBranding] === CustomBranding.MIAMI;

  const networkAdminMenu: MenuItem[] = [
    {
      icon: 'nc_icon-nc_home icon-sm',
      command: () => navigate('/'),
      id: 'navBarHome',
    },
    {
      label: 'Set Up',
      items: [
        // Option temporarily hidden (TEAMB-1969)
        // {
        //   label: 'Sites',
        //   icon: 'nc_icon-nc_levers icon-sm',
        //   command: () => navigate('/settings'),
        //   id: 'navBarSettings',
        // },
        {
          label: 'Classes & Student Rosters',
          icon: 'nc_icon-nc_join icon-sm',
          command: () => navigate('/classes-rosters'),
          id: 'navBarClassesRosters',
        },
        {
          label: 'Users',
          icon: 'nc_icon-nc_person icon-sm',
          items: [
            {
              label: 'Students',
              icon: 'nc_icon-nc_person icon-sm',
              command: () => navigate('/students'),
              id: 'navBarStudents',
            },
            {
              label: 'Teachers & Admins',
              icon: 'nc_icon-nc_person icon-sm',
              command: () => navigate('/teachers'),
              id: 'navBarTeachersAdmins',
            },
          ],
        },
      ],
    },
    {
      label: 'Plan',
      items: [
        {
          label: 'Units',
          icon: 'nc_icon-nc_unit icon-sm',
          command: () => navigate('/units'),
          id: 'navBarUnits',
        },
        {
          label: 'Skills',
          icon: 'nc_icon-nc_challenge icon-sm',
          command: () => navigate('/skills'),
          id: 'navBarSkills',
        },
      ],
    },
    {
      label: 'Monitor',
      items: [
        {
          label: miamiBrand ? 'Skill Challenge History' : 'Assessment History',
          icon: 'nc_icon-nc_challenge icon-sm',
          command: () => navigate('/assessment-history'),
          id: 'navBarAssessmentHistory',
        },
        {
          label: 'Progress',
          icon: 'nc_icon-nc_diagnostic icon-sm',
          command: () => navigate('/progress'),
          id: 'navBarProgress',
        },
        {
          label: 'Diagnostics',
          icon: 'nc_icon-nc_completed icon-sm',
          command: () => navigate('/diagnostics'),
          id: 'navBarDiagnostics',
          template: customDiagnosticOption,
        },
        {
          label: 'Reports Hub',
          icon: 'nc_icon-nc_export icon-sm',
          command: () => navigate('/reports-hub'),
          id: 'ReportsHubNavBar',
        },
      ],
    },
  ];

  const siteAdminMenu: MenuItem[] = [
    {
      icon: 'nc_icon-nc_home icon-sm',
      command: () => navigate('/'),
      id: 'navBarHome',
    },
    {
      label: 'Set Up',
      items: [
        // Option temporarily hidden (TEAMB-1969)
        // {
        //   label: 'Sites',
        //   icon: 'nc_icon-nc_levers icon-sm',
        //   command: () => navigate('/settings'),
        //   id: 'navBarSettings',
        // },
        {
          label: 'Classes & Student Rosters',
          icon: 'nc_icon-nc_join icon-sm',
          command: () => navigate('/classes-rosters'),
          id: 'navBarClassesRosters',
        },
        {
          label: 'Users',
          icon: 'nc_icon-nc_person icon-sm',
          items: [
            {
              label: 'Students',
              icon: 'nc_icon-nc_person icon-sm',
              command: () => navigate('/students'),
              id: 'navBarStudents',
            },
            {
              label: 'Teachers & Admins',
              icon: 'nc_icon-nc_person icon-sm',
              command: () => navigate('/teachers'),
              id: 'navBarTeachersAdmins',
            },
          ],
        },
      ],
    },
    {
      label: 'Plan',
      items: [
        {
          label: 'Units',
          icon: 'nc_icon-nc_unit icon-sm',
          command: () => navigate('/units'),
          id: 'navBarUnits',
        },
        {
          label: 'Skills',
          icon: 'nc_icon-nc_challenge icon-sm',
          command: () => navigate('/skills'),
          id: 'navBarSkills',
        },
      ],
    },
    {
      label: 'Monitor',
      items: [
        {
          label: miamiBrand ? 'Skill Challenge History' : 'Assessment History',
          icon: 'nc_icon-nc_challenge icon-sm',
          command: () => navigate('/assessment-history'),
          id: 'navBarAssessmentHistory',
        },
        {
          label: 'Assignments',
          icon: `${PrimeIcons.BOOK} text-2xl py-1`,
          command: () => navigate('/assignments'),
          id: 'navBarAssignments',
        },
        {
          label: 'Progress',
          icon: 'nc_icon-nc_diagnostic icon-sm',
          command: () => navigate('/progress'),
          id: 'navBarProgress',
        },
        {
          label: 'Diagnostics',
          icon: 'nc_icon-nc_completed icon-sm',
          command: () => navigate('/diagnostics'),
          id: 'navBarDiagnostics',
          template: customDiagnosticOption,
        },
        {
          label: 'Reports Hub',
          icon: 'nc_icon-nc_export icon-sm',
          command: () => navigate('/reports-hub'),
          id: 'ReportsHubNavBar',
        },
      ],
    },
  ];

  const teacherMenu: MenuItem[] = [
    {
      icon: 'nc_icon-nc_home icon-sm',
      command: () => navigate('/'),
      id: 'navBarHome',
    },
    {
      label: 'Set Up',
      items: [
        {
          label: 'Classes & Student Rosters',
          icon: 'nc_icon-nc_join icon-sm',
          command: () => navigate('/classes-rosters'),
          id: 'navBarClassesRosters',
        },
        {
          label: 'Users',
          icon: 'nc_icon-nc_person icon-sm',
          items: [
            {
              label: 'Students',
              icon: 'nc_icon-nc_person icon-sm',
              command: () => navigate('/students'),
              id: 'navBarStudents',
            },
            {
              label: 'Teachers & Admins',
              icon: 'nc_icon-nc_person icon-sm',
              command: () => navigate('/teachers'),
              id: 'navBarTeachersAdmins',
            },
          ],
        },
      ],
    },
    {
      label: 'Plan',
      items: [
        {
          label: 'Units',
          icon: 'nc_icon-nc_unit icon-sm',
          command: () => navigate('/units'),
          id: 'navBarUnits',
        },
        {
          label: 'Skills',
          icon: 'nc_icon-nc_challenge icon-sm',
          command: () => navigate('/skills'),
          id: 'navBarSkills',
        },
      ],
    },

    // Hiding UI until we have more time
    {
      label: 'Monitor',
      items: [
        {
          label: miamiBrand ? 'Skill Challenge History' : 'Assessment History',
          icon: 'nc_icon-nc_challenge icon-sm',
          command: () => navigate('/assessment-history'),
          id: 'navBarAssessmentHistory',
        },
        {
          label: 'Assignments',
          icon: `${PrimeIcons.BOOK} text-2xl py-1`,
          command: () => navigate('/assignments'),
          id: 'navBarAssignments',
        },
        {
          label: 'Progress',
          icon: 'nc_icon-nc_diagnostic icon-sm',
          command: () => navigate('/progress'),
          id: 'navBarProgress',
        },
        {
          label: 'Diagnostics',
          icon: 'nc_icon-nc_completed icon-sm',
          command: () => navigate('/diagnostics'),
          id: 'navBarDiagnostics',
          template: customDiagnosticOption,
        },
        {
          label: 'Reports Hub',
          icon: 'nc_icon-nc_export icon-sm',
          command: () => navigate('/reports-hub'),
          id: 'ReportsHubNavBar',
        },
      ],
    },
  ];

  if (userRedux.roles.some(role => role.name === Roles.NETWORK_ADMIN)) {
    return networkAdminMenu;
  } else if (userRedux.roles.some(role => role.name === Roles.SITE_ADMIN)) {
    return siteAdminMenu;
  } else {
    return teacherMenu;
  }
};
